<template>
  <div class="alert-wrap" :style="{ top: topPosition + 'px' }">
    <v-alert
      :value="value"
      :type="alertType"
      class="alert-bar"
      transition="scale-transition"
    >
      <div class="alert-bar--content">
        {{ message }}
        <v-btn small fab dark flat @click="closeAlert()">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
    </v-alert>
  </div>
</template>

<script>
export default {
  props: {
    alertValue: {
      type: Boolean,
      default: false
    },
    alertMessage: {
      type: String,
      required: true
    },
    alertType: {
      type: String,
      default: 'success'
    },
    topPosition: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      value: this.alertValue,
      message: this.alertMessage
    }
  },

  watch: {
    alertValue(newValue, oldValue) {
      this.value = newValue
      if (newValue) {
        setTimeout(() => {
          this.value = false
          this.$emit('disable-alert')
        }, 5000)
      }
    },

    alertMessage(newValue, oldValue) {
      this.message = newValue
    }
  },

  methods: {
    closeAlert() {
      this.value = false
      this.message = null
    }
  }
}
</script>

<style lang="sass" scoped>
.alert-wrap
  position: absolute
  left: 50%
  width: 100%
  transform: translateX(-50%)
  z-index: 9999

.alert-bar
  font-size: 1.2rem
  padding: 0 20px !important
  &--content
    display: flex
    flex-direction: row
    align-items: center
    justify-content: space-between

.bottom-position
  bottom: 0
</style>
